import columns from '../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn, NumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('', 'name').withWidth(254.4),
      ],
    },
    {
      Header: 'Generated from PREDES',
      columns: [
        new NumberColumn('In', 'generatedFromPredes.in').withWidth(90),
        new NumberColumn('Out', 'generatedFromPredes.out').withWidth(90),
        new NumberColumn('Total', 'generatedFromPredes.total').withWidth(90),
      ],
    },
    {
      Header: 'Manual Pre-Advise',
      columns: [
        new NumberColumn('In', 'manualPreadvice.in').withWidth(90),
        new NumberColumn('Out', 'manualPreadvice.out').withWidth(90),
        new NumberColumn('Total', 'manualPreadvice.total').withWidth(90),
      ],
    },
    {
      Header: 'Center Initiated Repat',
      columns: [
        new NumberColumn('In', 'centralRepatriation.in').withWidth(90),
        new NumberColumn('Out', 'centralRepatriation.out').withWidth(90),
        new NumberColumn('Total', 'centralRepatriation.total').withWidth(90),
      ],
    },
    {
      Header: 'Internal Repat',
      columns: [
        new NumberColumn('In', 'internalRepatriation.in').withWidth(90),
        new NumberColumn('Out', 'internalRepatriation.out').withWidth(90),
        new NumberColumn('Total', 'internalRepatriation.total').withWidth(90),
      ],
    },
    {
      Header: 'Total',
      columns: [
        new NumberColumn('In', 'total.in').withWidth(90),
        new NumberColumn('Out', 'total.out').withWidth(90),
        new NumberColumn('Flux', 'total.flux').withWidth(90),
      ],
    },
    {
      Header: '',
      columns: [
        new NumberColumn('Balance Modification', 'balanceModificationCount').withWidth(112.2),
        new NumberColumn('Balance on Hand', 'balanceOnHand').withWidth(112.2),
      ],
    },
  ];
};
